import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './purchase-order-header.messages';
import styles from './purchase-order-pdf-dropdown.styles.module.less';
import { PurchaseOrderPrintDocumentType, usePrintPurchaseOrder } from '../data/hooks/use-print-purchase-order';

export const PurchaseOrderPdfDropdown = ({ disabled = false, purchaseOrderIds, data }) => {
  const { onClick: printPdf, isDisabled } = usePrintPurchaseOrder({
    purchaseOrderIds,
    data,
  });

  const printDisabled = disabled || isDisabled;

  return (
    <DropdownMenu
      className={classnames(styles['menu-print-dropdown'], {
        [styles['menu-dropdown-disabled']]: printDisabled,
      })}
      disabled={printDisabled}
    >
      <DropdownMenuToggler className={classnames(styles['actions-button'])}>
        <Text className={styles['actions-text']} textType={TextType.Label} value={messages.printPdf} />
      </DropdownMenuToggler>

      <DropdownMenuItem onClick={() => printPdf(PurchaseOrderPrintDocumentType.ordered)}>
        <FormattedMessage {...messages.printOrderSummary} />
      </DropdownMenuItem>

      <DropdownMenuItem onClick={() => printPdf(PurchaseOrderPrintDocumentType.received)}>
        <FormattedMessage {...messages.printReceivedSummary} />
      </DropdownMenuItem>
    </DropdownMenu>
  );
};
